module.exports = __webpack_public_path__ + "static/media/dot-circle.d3f63945.svg";